import React, { useEffect } from 'react';
import RefundPolicy from './RefundPolicy';

const TracsessTuneRefund: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <RefundPolicy
      appName="Tracsess Tune"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/tune/R%26CP_Tracsess_Tune.pdf"
      title="Tracsess Tune - Refund and Cancellation Policy"
    />
  );
};

export default TracsessTuneRefund; 